import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const CgPersonaDashboardPage = lazy(() =>
  import('../pages/connected-grc/PersonaDashboardPage').then((m) => ({ default: m.PersonaDashboardPage }))
)
const CgCrosswalksPage = lazy(() =>
  import('../pages/connected-grc/CrosswalksPage').then((m) => ({ default: m.CrosswalksPage }))
)
const CgCommonControlsPage = lazy(() =>
  import('../pages/connected-grc/CommonControlsPage').then((m) => ({ default: m.CommonControlsPage }))
)
const CgMetricsMonitorPage = lazy(() =>
  import('../pages/connected-grc/MetricsMonitorPage').then((m) => ({ default: m.MetricsMonitorPage }))
)

export const connectedGrcRoutes: RouteObject[] = [
  {
    path: 'connected-grc',
    children: [
      { index: true, element: <CgPersonaDashboardPage /> },
      { path: 'dashboard', element: <CgPersonaDashboardPage /> },
      { path: 'crosswalks', element: <CgCrosswalksPage /> },
      { path: 'common-controls', element: <CgCommonControlsPage /> },
      { path: 'metrics', element: <CgMetricsMonitorPage /> },
    ],
  },
]
